import { render, staticRenderFns } from "./FotoProdutoAdicionar.vue?vue&type=template&id=364431d1"
import script from "./FotoProdutoAdicionar.vue?vue&type=script&lang=js"
export * from "./FotoProdutoAdicionar.vue?vue&type=script&lang=js"
import style0 from "./FotoProdutoAdicionar.vue?vue&type=style&index=0&id=364431d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports